<template>
    <div class="kgk-user-runs">
        <!--<h1>Topliste Läufer</h1>-->
        <div v-if="loading || loadingUser" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="runs">
            <!-- <div style="margin-top:10px;margin-bottom:30px;">
                <div v-if="!competitive.edit">
                    <div v-if="!competitive.value">
                        <p style="margin-bottom:0;"><i class="fas fa-info-circle"></i> Du spendest Kilometer ohne Wettbewerb mit anderen Teilnehmern.</p>
                        <p>Deine Läufe werden auch ohne Verifizierung gewertet, du erhältst aber keine Position in der Rangliste.</p>
                    </div>
                    <div v-else>
                        <p style="margin-bottom:0;"><i class="fas fa-info-circle"></i> Du misst dich im Wettbewerb mit anderen Läufern und Teams.</p>
                        <p>Du wirst in der Rangliste geführt, es werden dafür aber nur verifizierte Läufe gewertet.</p>
                        <--<p>Deine Läufe werden nur mit Verifizierung gewertet und du erhältst deine Position in der Rangliste.</p>--
                    </div>
                    <button type="button" @click.prevent="competitive.edit = true"><-- @click.prevent="createRunButton()" --
                        <i class="fas fa-cog"></i>
                        <span class="button-text">Anpassen</span>
                    </button>
                </div>
                <div v-else style="max-width:400px;margin-left:auto;margin-right:auto;text-align:left;">
                    <ul style="list-style:none;padding:0;margin:0 0 10px 0;">
                        <li>
                            <label>
                                <input type="radio" name="competitive" :value="false" v-model="competitive.value"> Ich möchte nur Kilometer spenden.
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="radio" name="competitive" :value="true" v-model="competitive.value"> Ich möchte mich auch mit anderen Läufern und Teams messen.
                            </label>
                        </li>
                    </ul>
                    <div style="text-align:center">
                        <button type="button" :disabled="competitive.value === competitive.initialValue || competitive.loading" @click.prevent="updateCompetitive"><-- @click.prevent="createRunButton()" --
                            <i class="fas " :class="{'fa-save': !competitive.loading, 'fa-spin fa-spinner': competitive.loading}"></i>
                            <span class="button-text">Speichern</span>
                        </button>
                    </div>
                </div>
            </div>-->
            <table v-if="runs.length > 0">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <!--<td>Avatar</td>-->
                        <th>Distanz</th>
                        <th v-if="user.run_type==1">Schritte</th>
                        <th>Dauer</th>
                        <th>Pace</th>
                        <th>Zeitpunkt</th>
                        <th v-if="user.competitive">Gültig</th>
                        <th>Quelle</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(run, index) in runs"
                        :key="run.identifier">
                        <td>
                            <span class="kgk-ranking-num">{{ runs.length - index }}.</span>
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Distanz:</div>
                            <i v-if="run.run_type==1" class="fas fa-shoe-prints"></i>
                            <i v-else class="fas fa-running"></i> 
                            {{ convertNumberReadable(Math.round(run.length * 100) / 100) }} km
                        </td>
                        <td v-if="user.run_type==1">
                            <div class="kgk-mobile-th">Schritte</div>
                            {{ convertNumberReadable(run.steps) }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Dauer:</div>
                            <i class="fas fa-stopwatch"></i> {{ durationReadable(run.duration) }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Pace:</div>
                            {{ convertNumberReadable(Math.round((run.duration / 60) / run.length * 100) / 100) }} min/km
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Zeitpunkt:</div>
                            <i class="fas fa-calendar-alt"></i> {{ convertDatetimeReadable(run.ran_at) }} <i class="fas fa-clock"></i>
                        </td>
                        <td v-if="user.competitive">
                            <div class="kgk-mobile-th">Gültig:</div>
                            <span v-if="run.invalidated" class="kgk-error" v-tooltip="'Nachweisfoto /-screenshot wurde nicht akzeptiert'">
                                <i class="fas fa-exclamation-triangle"></i>
                            </span>
                            <span v-else-if="run.valid">
                                <i class="fas fa-check"></i>
                                <!--<i v-if="run.screenshot_url" class="fas fa-check" :v-tooltip="getScreenshotTooltipContent(run.screenshot_url)"></i>
                                <i v-else class="fas fa-check"></i>-->
                            </span>
                            <span v-else class="kgk-error" v-tooltip="'Nachweisfoto /-screenshot fehlt'">
                                <i class="fas fa-times"></i>
                                <!--<i class="fas fa-info-circle"></i>-->
                            </span>
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Quelle:</div>
                            <span v-if="run.sourced_from==1">Strava</span>
                            <span v-else>Manuell</span>
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Aktionen:</div>
                            <div class="kgk-actions">
                                <a v-if="run.run_type==1" @click.prevent="editRunStepsButton(run)" href="#" title="Lauf bearbeiten">
                                    <i class="fas fa-edit"></i>
                                </a>
                                <a v-else @click.prevent="editRunButton(run)" href="#" title="Lauf bearbeiten">
                                    <i class="fas fa-edit"></i>
                                </a>
                                <a @click.prevent="deleteRunButton(run)" href="#" title="Lauf löschen">
                                    <i v-if="!run.loading" class="fas fa-trash fa-fw"></i>
                                    <i v-else class="fas fa-spinner fa-spin fa-fw"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="kgk-mobile-td-hidden">&nbsp;</td>
                        <td>
                            <div class="kgk-mobile-th">Distanz gesamt:</div>
                            <b>&sum; {{ convertNumberReadable(Math.round(totalLength * 100) / 100) }} km</b>
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Dauer gesamt:</div>
                            <b>&sum; {{ durationReadable(totalDuration) }}</b>
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Durchschn. Pace</div>
                            <b>&Oslash; {{ convertNumberReadable(Math.round(averagePace * 100) / 100) }} min/km</b>
                        </td>
                        <td class="kgk-mobile-td-hidden">&nbsp;</td>
                        <td class="kgk-mobile-td-hidden">&nbsp;</td>
                        <td class="kgk-mobile-td-hidden"></td>
                    </tr>
                </tbody>
            </table>
            <div v-else>
                <div class="spacer"></div>
                <p>Du hast bisher noch keinen Lauf eingetragen.</p>
            </div>
        </div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import user from '../../api/user';
    import runApi from '../../api/runs';
    import donateModal from '../../helpers/donate-modal';
    import CreateRunForm from './CreateRunForm';
    import CreateRunStepsForm from './CreateRunStepsForm';

    export default {
        name: 'RunsList',
        props: {
            forceReload: Number
        },
        data() {
            return {
                runs: null,
                user: null,
                competitive: {
                    value: null,
                    initialValue: null,
                    edit: false,
                    loading: false,
                },
                loading: false,
                loadingUser: false,
                error: null,
            }
        },
        computed: {
            totalLength: function() {
                // run.length comes from the API as a string (Laravel's decimal
                // cast serializes to string to preserve precision) -- without
                // Number() this silently does string concatenation instead of
                // summation, e.g. 0 + "1.291" + "3.777" = "01.2913.777", and
                // Math.round() on that yields NaN.
                return this.runs.reduce((total, run) => total + Number(run.length), 0);
            },
            totalDuration: function() {
                return this.runs.reduce((total, run) => total + run.duration, 0);
            },
            averagePace: function() {
                return (this.totalDuration / 60) / this.totalLength;
            },
        },
        methods: {
            loadUserDetails() {
                this.loadingUser = true;

                user.getDetails(
                    this,
                    data => {
                        this.user = data.user;
                        this.competitive.value = this.competitive.initialValue = data.user.competitive;

                        donateModal.openDonateModalIfNeeded(this.$modal, this.user);
                    },
                    () => this.error = 'Es ist ein Fehler aufgetreten',
                    () => this.loadingUser = false,
                );
            },
            loadRuns() {
                this.loading = true;

                user.getRuns(
                    this,
                    data => this.runs = data.runs.map(invite => {
                        invite.loading = false;
                        //invite.issuer_username = this.getMemberUsername(invite.issuer_identifier);
                        return invite;
                    }),
                    () => this.error = 'Es ist ein Fehler aufgetreten',
                    () => this.loading = false,
                );
            },
            durationReadable(duration) {
                const hours = Math.floor(duration / 60 / 60);
                const minutes = Math.floor((duration % (60 * 60)) / 60);
                const seconds = duration % 60;

                //return (hours > 0 ? hours + ':' : '') + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
                return hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
            },

            updateCompetitive() {
                this.competitive.loading = true;

                user.updateCompetitive(
                    this,
                    this.competitive.value,
                    () => {
                        this.user.competitive = this.competitive.initialValue = this.competitive.value;
                        this.competitive.edit = false;
                    },
                    () => alert('Es ist ein Fehler aufgetreten'),
                    () => this.competitive.loading = false,
                );
            },

            editRunButton(run) {
                const _this = this;

                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'Speichern';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    }
                };

                this.$modal.show('dialog', {
                    title: 'Lauf bearbeiten',
                    component: CreateRunForm,
                    props: {
                        edit: true,
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger,
                        runIdentifier: run.identifier,
                        competitive: this.user.competitive,
                    },
                    on: {
                        edited: _this.handleEdited,
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            default: true,
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        saveButton
                    ]
                });
            },
            editRunStepsButton(run) {
                const _this = this;
                
                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'Speichern';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    }
                };

                this.$modal.show('dialog', {
                    title: 'Lauf bearbeiten',
                    component: CreateRunStepsForm,
                    props: {
                        edit: true,
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger,
                        runIdentifier: run.identifier,
                        competitive: this.user.competitive,
                    },
                    on: {
                        edited: _this.handleEdited,
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            default: true,
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        saveButton
                    ]
                });
            },
            handleEdited() {
                console.log('handleEdited', this);
                //this.selection = selectedUsers;

                this.$modal.hide('dialog');

                this.$emit('edited');
            },

            deleteRunButton(run) {
                const _this = this;

                let fired = false;

                this.$modal.show('dialog', {
                    title: 'Lauf löschen',
                    text: `Möchten Sie den Lauf über <b>${run.length} km</b> vom ${run.ran_at} Uhr wirklich löschen?`,
                    buttons: [
                        {
                            title: 'Abbrechen',
                            default: true,
                        },
                        {
                            title: 'Ja, löschen',
                            handler() {
                                if( fired ) {
                                    return;
                                }

                                fired = true;
                                this.title += ' <i class="fas fa-spinner fa-spin"></i>';
                                _this.deleteRun(run, () => _this.$modal.hide('dialog'));
                            }
                        }
                    ]
                });
            },
            deleteRun(run, finallyCallback) {
                /*if( run.loading ) {
                    return;
                }

                run.loading = true;*/

                runApi.delete(
                    this,
                    run.identifier,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Lauf entfernt',
                            text: 'Der Lauf wurde erfolgreich gelöscht.'
                        });

                        this.$emit('deleted');

                        this.loadRuns();
                    },
                    e => {
                        //run.loading = false;

                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        if( finallyCallback ) {
                            finallyCallback();
                        }
                    }
                )
            },

            getScreenshotTooltipContent(url) {
                if( !url ) {
                    return null;
                }

                return `<img src="${url}" style="max-width:260px; height: auto; display: block">`;
            }
        },
        watch: {
            forceReload: {
                immediate: true,
                handler() {
                    this.loadRuns();
                }
            },
        },
        mounted() {
            this.loadUserDetails();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
